module.exports = __webpack_public_path__ + "static/media/caregiver-desktop-header.513bd6ef.jpg";